import { Flex, Text } from '@chakra-ui/react';

import Card from 'components/card/Card';
import { useAppSelector } from 'hooks';
import { StepOne, StepTwo } from 'components/shared/steps';
import StepContainer from 'components/shared/steps/StepContainer';
import StepHeader from 'components/shared/steps/StepHeader';
import StatusBadge from 'components/shared/steps/StatusBadge';
import { SIGNING_STATUS_COMPLETED } from 'variables/constants';

const SigningSteps = () => {
  const signing = useAppSelector((state) => state.commercialForm.signing);
  const isFinalStepEnabled = signing?.status === SIGNING_STATUS_COMPLETED;

  return (
    <Card mb="20px">
      <Text fontSize="lg" fontWeight="bold" mb="20px">
        Signing
      </Text>

      <Flex justify="space-between" align="center" gap="20px">
        <StepOne formStateKey="commercialForm" />
        <StepTwo formStateKey="commercialForm" />

        <StepContainer isEnabled={isFinalStepEnabled} showArrow={false}>
          <StepHeader
            stepNumber={3}
            title="JIRA Ticket Issued"
            isEnabled={isFinalStepEnabled}
          />

          {isFinalStepEnabled ? (
            <StatusBadge status="success">
              Submission has been completed and JIRA ticket issued
            </StatusBadge>
          ) : (
            <StatusBadge status="disabled">
              Sign documents to complete submission
            </StatusBadge>
          )}
        </StepContainer>
      </Flex>
    </Card>
  );
};

export default SigningSteps;
